export default __webpack_public_path__ + "static/kubernetes-a6acecc9bc4c397999ef9f2975a69d56.svg";